import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Avatar } from '@mui/material';
import ResumeInfo from '../../components/ResumeInfo';
import useMobile from '../../hooks/useMobile';
import { formatDateRange, convertToTimeZone } from '@/locales/dates';
const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

function EventResume({
  event: {
    event: { name, start_date, end_date, logo },
    location: { venue, address, latitude, longitude } = {
      venue: '',
      address: '',
    },
  },
  moreInfo = () => {},
}) {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const date = convertToTimeZone(start_date).format(
    'dddd, DD MMMM YYYY. h:mm A',
  );

  const calendarStartDate =
    convertToTimeZone(start_date).format('YYYYMMDDTHHmmss');

  const calendarEndDate = convertToTimeZone(end_date).format('YYYYMMDDTHHmmss');

  return (
    <Grid container spacing={2} sx={{ mt: isMobile ? '-16px' : 2 }}>
      {!isMobile && (
        <Grid item md={2}>
          <Avatar
            alt={name}
            src={logo}
            sx={{ width: 112, height: 112, mt: 2 }}
          />
        </Grid>
      )}
      <Grid item md={10} sm={12}>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <Typography variant="h5" paragraph>
              {name}
            </Typography>
          </Grid>
          <Grid item md={4} sm={12}>
            <ResumeInfo
              title={date}
              link={t('checkout.global.addCalendar')}
              subtitle={formatDateRange(start_date, end_date)}
              url={`http://www.google.com/calendar/render?action=TEMPLATE&text=${name}&dates=${calendarStartDate}/${calendarEndDate}&location=${venue}`}
              iconify="ic:baseline-calendar-today"
              sx={{
                '& h6': {
                  textTransform: 'capitalize',
                },
                'mb': 2,
              }}
            />
          </Grid>
          <Grid item md={4} sm={12}>
            {venue !== 'Online' && (
              <ResumeInfo
                title={venue}
                subtitle={address}
                link={t('checkout.global.viewLocation')}
                url={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${latitude},${longitude}`}
                iconify="ic:baseline-place"
                sx={{
                  mb: 2,
                }}
              />
            )}
            {venue === 'Online' && (
              <ResumeInfo
                title={venue}
                iconify="ic:baseline-place"
                sx={{
                  mb: 2,
                }}
              />
            )}
          </Grid>
          {!isMobile && (
            <Grid item md={4}>
              <ResumeInfo
                link={t('checkout.global.moreEventInfo')}
                onClick={moreInfo}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

EventResume.propTypes = {
  event: PropTypes.object.isRequired,
  showAddress: PropTypes.bool,
};

export default EventResume;
